// Labels pour les différents types de transactions
export const getPriceLabels = (transactionType: string) => {
  switch (transactionType) {
    case 'rent':
      return {
        sellerPrice: 'Loyer hors charges',
        commission: 'Montant des charges',
        finalPrice: 'Loyer Complet',
      };
    case 'short-rent':
      return {
        sellerPrice: 'Coût /Nuit',
        commission: 'Commission',
        finalPrice: 'Coût Total /Nuit',
      };
    case 'sale':
    default:
      return {
        sellerPrice: 'Prix net vendeur',
        commission: 'Commission Agence',
        finalPrice: 'Prix de vente',
      };
  }
};